import React from 'react';
import PropTypes from 'prop-types';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import { FormattedMessage } from 'react-intl';
import { Column } from 'components/shared/Layout';
import { currencyShape } from 'constants/propTypes';
import { StyledPriceTable, StyledTableRow } from '../HotelCompensation.styles';

const PriceTable = ({ currency, totalPrice, refundAmount }) => (
  <StyledPriceTable>
    <StyledTableRow span={6} start={1}>
      <Column span={8}>
        <FormattedMessage id="hotelCompensation.hotelPrice" />
      </Column>
      <Column span={8} data-cy="total-price">
        <FormattedCurrency data-testid="totalPrice" currency={currency} amount={totalPrice} />
      </Column>
    </StyledTableRow>
    <StyledTableRow span={6} start={1}>
      <Column span={8}>
        <FormattedMessage id="prrRefund.refundAmount" />
      </Column>
      <Column span={8} data-cy="refund-amount">
        <FormattedCurrency data-testid="refundAmount" currency={currency} amount={refundAmount} />
      </Column>
    </StyledTableRow>
  </StyledPriceTable>
);

PriceTable.propTypes = {
  currency: currencyShape,
  totalPrice: PropTypes.number,
  refundAmount: PropTypes.number
};

export default PriceTable;
